import { render, staticRenderFns } from "./planoSemanalInfantil.vue?vue&type=template&id=2175d676"
import script from "./planoSemanalInfantil.vue?vue&type=script&lang=js"
export * from "./planoSemanalInfantil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports